import { Card, CardProps } from "antd";
import React from "react";

interface CustomCardProps extends CardProps {
  shadow?: boolean;
  rounded?: string;
  padding?: string;
  fillColor?: string;
  children: React.ReactNode;
  headerBorderRadius?: string;
  hideBody?: boolean;
}

const CustomCard: React.FC<CustomCardProps> = (props: CustomCardProps) => {
  const {
    shadow = true,
    rounded = 12,
    padding = 0,
    fillColor = "#4586f0",
    headerBorderRadius,
    hideBody = false,
    ...rest
  } = props;
  return (
    <Card
      styles={{
        body: {
          padding: padding,
          border: "none",
          outline: "none",
          display: hideBody ? "none" : undefined,
        },
        header: {
          background: fillColor,
          borderRadius: headerBorderRadius
            ? `${headerBorderRadius}px`
            : undefined,
        },
      }}
      bordered={false}
      className={`${shadow && "card-shadow"} rounded-[${rounded}px]`}
      {...rest}
    >
      {props.children}
    </Card>
  );
};
export default CustomCard;
